export const iconFontAwesomeArrowsRightLeft = (
	<i className="fa-solid fa-right-left"></i>
);
